export const TIME_TO_REDIRECT = 2000; // 2 segundos para enviar para o login

export const STATUS_CODE = {
	Unauthorized: 401,
};

export const AUTH_MANAGER_KEYS = {
	TOKEN: '@ProjectName:token',
	REFRESH_TOKEN: '@ProjectName:refreshToken',
	USER: '@ProjectName:user',
	SESSION_LOG: '@ProjectName:sessionLog',
};
